export default "__VITE_ASSET__uwAXl7Ut__"